import { action } from "satcheljs";
import type { SearchScenarioId } from "owa-search-store";

export interface SET_SEARCH_TEXTActionMessage {
    searchText: string;
    scenarioId: SearchScenarioId;
}
export const setSearchText: (searchText: string, scenarioId: SearchScenarioId) => SET_SEARCH_TEXTActionMessage = action("SET_SEARCH_TEXT", (searchText: string, scenarioId: SearchScenarioId): SET_SEARCH_TEXTActionMessage => ({
    searchText,
    scenarioId,
}));
